import React, { useState } from 'react'
import LogoContainer from '../components/LogoContainer'
import SektorelHaberler from '../components/blog-haberler/SektorelHaberler'
import TeknikBilgilerVeMakaleler from '../components/blog-haberler/TeknikBilgilerVeMakaleler'
import { Link, Outlet } from 'react-router-dom'
import BlogMenu from '../components/blog-haberler/BlogMenu'
import { motion } from 'framer-motion';
import {  containerVariants} from '../script/animationVariants'; // Animasyon varyantlarını içe aktarıyoruz

const BlogHaberler = () => {

    const [first, setfirst] = useState(1)
    return (
        <div className=' min-h-screen bg-white pb-20'>
     
            <div className=' grid grid-cols-14 md:grid-cols-8'>

                <div className='col-start-2 col-span-12  md:col-start-2 md:col-span-6 '>

                    <div className='text-45 font-light mb-10'>Blog / Haberler</div>
<BlogMenu/>



                    <motion.div 
            variants={containerVariants} 
            initial="hidden" 
            whileInView="visible" className='  grid grid-cols-1 md:grid-cols-2 gap-3'>

                        <Outlet />




                    </motion.div>

                </div>


            </div>
        </div>



    )
}

export default BlogHaberler